import clientService from '@/api/client'
import { CLIENT } from '../types'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    clients: [],
    clientId: '',
    clientName: '',
    originalClientId: null
  },
  getters: {
    originalClientId (state) {
      return state.originalClientId
    },
    clientId (state) {
      return state.clientId
    },
  },
  mutations: {
    [CLIENT.CLIENT_SET] (state, clients) {
      state.clients = clients
    },
    [CLIENT.SET_CLIENT_CONFIG] (state, item) {
      if (state.originalClientId === null) {
        state.originalClientId = state.clientId
      }
      state.clientId = item.id
      state.clientName = item.name
      state.clientDesksQuota = item.desksQuota
    },
    [CLIENT.RESTORE_CLIENT_CONFIG] (state) {
      state.clientId = state.originalClientId
      state.originalClientId = null
      state.clientName = ''
    },
    [CLIENT.SET_CLIENT_ID] (state, id) {
      state.clientId = id
    },
    [CLIENT.SET_CLIENT_ADMIN] (state, obj){
      state.clientId = obj.clientId
      state.clientName = obj.clientName
      state.originalClientId = obj.originalClientId
    },
  },
  actions: {
    getClientsList: function ({ commit, dispatch }) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        clientService.getClients().then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          commit(CLIENT.CLIENT_SET, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    addClient: function ({dispatch}, client) {
      return new Promise((resolve, reject) => {
        clientService.addClient(client).then(() => {
          dispatch('getClientsList').then(() => {
            resolve()
          })
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$showMessage('clientAlreadyExists')
          }
          reject(error)
        })
      })
    },
    editClient: function ({dispatch}, client) {
      return new Promise((resolve, reject) => {
        clientService.editClient(client).then(() => {
          dispatch('getClientsList').then(() => {
            resolve()
          }).catch((error) => {
            reject(error)
          })
        })
      })
    },
    setClient ({commit}, item) {
      commit(CLIENT.SET_CLIENT_CONFIG, item)
    },
    restoreClient ({commit}) {
      commit(CLIENT.RESTORE_CLIENT_CONFIG)
      router.push('/')
    },
    setClientId ({commit}, id) {
      commit(CLIENT.SET_CLIENT_ID, id)
    },
    setClientAdmin ({commit}, obj) {
      commit(CLIENT.SET_CLIENT_ADMIN, obj)
    },
  }
}
